import { Box, Paper, Tab, Tabs } from '@mui/material';
import { styled } from '@mui/material/styles';

export const HistoricalInformationContainer = styled(Paper)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  borderBottom: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.spacing(1),
  backgroundColor: theme.palette.common.white,
  padding: theme.spacing(3),
}));

export const StyledTabs = styled(Tabs)(() => ({
  width: '100%',
}));

export const StyledTab = styled(Tab)(() => ({
  flex: 1,
}));

export const HistoricalInformationHeader = styled(Box)(({ theme }) => ({
  width: '100%',
  minWidth: '620px',
  maxWidth: '620px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  gap: theme.spacing(4),
  [theme.breakpoints.down('md')]: {
    width: '100%',
    maxWidth: '100%',
    minWidth: 'auto',
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));
